import { render, staticRenderFns } from "./LinkedTestComponent.vue?vue&type=template&id=60ff143a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./LinkedTestComponent.vue?vue&type=script&lang=js&"
export * from "./LinkedTestComponent.vue?vue&type=script&lang=js&"
import style0 from "./LinkedTestComponent.vue?vue&type=style&index=0&id=60ff143a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff143a",
  null
  
)

component.options.__file = "LinkedTestComponent.vue"
export default component.exports